import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { L } from '../i18n/LocaleProvider';

const groupId = name => name.toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const ServiceCapabilities = ({ service }) => {
  const { hash } = useLocation();
  const [expanded, setExpanded] = useState('');
  useEffect(() => {
    const targetId = hash.slice(1);
    if (!service.groups.some(group => groupId(group.name) === targetId)) return;
    setExpanded('capabilities');
    const timer = setTimeout(() => {
      const target = document.getElementById(targetId);
      if (!target) return;
      if (window.__techspitzeLenis) window.__techspitzeLenis.scrollTo(target, { offset: -135, immediate: true, force: true });
      else target.scrollIntoView({ block: 'start' });
    }, 380);
    return () => clearTimeout(timer);
  }, [hash, service.groups]);
  return <L><Accordion type="single" collapsible value={expanded} onValueChange={setExpanded} className="service-capabilities">
    <AccordionItem value="capabilities" className="capabilities-item">
      <AccordionTrigger className="capabilities-trigger" data-testid={`service-capabilities-toggle-${service.id}`}><span>Explore all capabilities</span></AccordionTrigger>
      <AccordionContent data-testid={`service-capabilities-content-${service.id}`}>
        <div className="capabilities-grid">{service.groups.map((group, i) => <div id={groupId(group.name)} className="capability-group" key={group.name} data-testid={`capability-group-${service.id}-${i}`}><h3>{group.name}</h3><ul>{group.items.map(item => <li key={item}>{item}</li>)}</ul></div>)}</div>
      </AccordionContent>
    </AccordionItem>
  </Accordion></L>;
};